(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 72275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86893);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Advertisement = function Advertisement(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? "#" : _ref$url,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? "/temp/add-row.png" : _ref$src,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "900" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "110" : _ref$height,
      className = _ref.className,
      style = _ref.style,
      _ref$isPlaceholder = _ref.isPlaceholder,
      isPlaceholder = _ref$isPlaceholder === void 0 ? false : _ref$isPlaceholder;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true),
      show = _useState[0],
      setShow = _useState[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: show && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      style: {
        style: style
      },
      className: "flex justify-center ".concat(className ? className : ""),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "relative",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
          onClick: function onClick() {
            return setShow(false);
          },
          className: "absolute right-[1px] top-[1px] bg-white z-10 hover:text-red-600 transition-all",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_3__/* .FiX */ .q5L, {})
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
          href: url,
          rel: "nofollow",
          target: "_blank",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), {
            alt: "Advertisement",
            src: src,
            width: width,
            height: height,
            style: {
              height: height
            }
          })
        }), isPlaceholder && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: "absolute text-white text-[50px] font-semibold z-10 w-full text-center",
          style: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          },
          children: [width, " x ", height]
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Advertisement);

/***/ }),

/***/ 75693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72275);
/* harmony import */ var _hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14418);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var AdvertisementRow = function AdvertisementRow(_ref) {
  var _ref$srcDesktop = _ref.srcDesktop,
      srcDesktop = _ref$srcDesktop === void 0 ? "/temp/add-row.png" : _ref$srcDesktop,
      _ref$srcMobile = _ref.srcMobile,
      srcMobile = _ref$srcMobile === void 0 ? "/temp/add-column-sm.png" : _ref$srcMobile,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? "#" : _ref$url;

  var _useWindowDimensions = (0,_hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(),
      width = _useWindowDimensions.width;

  if (width > 900) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(___WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      url: url,
      width: 920,
      height: 90,
      src: srcDesktop
    });
  } else {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(___WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      url: url,
      width: 336,
      height: 280,
      src: srcMobile
    });
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (AdvertisementRow);

/***/ }),

/***/ 17948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./_recoil/_state/search_popup.js
var search_popup = __webpack_require__(2511);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(15825);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/theme/layout/index.js + 17 modules
var layout = __webpack_require__(81496);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./_unisearch/common/skeleton/index.jsx
var skeleton = __webpack_require__(21197);
// EXTERNAL MODULE: ./_modules/study/common/sections/countdown_two/loader/loader.module.scss
var loader_module = __webpack_require__(51928);
var loader_module_default = /*#__PURE__*/__webpack_require__.n(loader_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/common/sections/countdown_two/loader/index.jsx





var CountdownLoader = function CountdownLoader() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "container",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (loader_module_default()).grid,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        className: (loader_module_default()).counter
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (loader_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          className: (loader_module_default()).heading
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          className: (loader_module_default()).text
        })]
      })]
    })
  });
};

/* harmony default export */ var loader = (CountdownLoader);
// EXTERNAL MODULE: ./_modules/study/home/banner/loader/loader.module.scss
var loader_loader_module = __webpack_require__(74544);
var loader_loader_module_default = /*#__PURE__*/__webpack_require__.n(loader_loader_module);
;// CONCATENATED MODULE: ./_modules/study/home/banner/loader/index.jsx





var HomeBannerLoader = function HomeBannerLoader() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (loader_loader_module_default()).grid,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          className: (loader_loader_module_default()).title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          className: (loader_loader_module_default()).sub_title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          className: (loader_loader_module_default()).search
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          height: 520
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (loader_loader_module_default()).features,
      children: new Array(6).fill(1).map(function (_, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          height: 172
        }, i);
      })
    })]
  });
};

/* harmony default export */ var banner_loader = (HomeBannerLoader);
// EXTERNAL MODULE: ./_modules/study/home/find_university/loader/loader.module.scss
var find_university_loader_loader_module = __webpack_require__(38814);
var find_university_loader_loader_module_default = /*#__PURE__*/__webpack_require__.n(find_university_loader_loader_module);
;// CONCATENATED MODULE: ./_modules/study/home/find_university/loader/index.jsx





var HomeBestUniversityLoader = function HomeBestUniversityLoader() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        className: (find_university_loader_loader_module_default()).title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        className: (find_university_loader_loader_module_default()).sub_title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (find_university_loader_loader_module_default()).grid,
        children: new Array(28).fill(1).map(function (_, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
            height: 70
          }, i);
        })
      })]
    })
  });
};

/* harmony default export */ var find_university_loader = (HomeBestUniversityLoader);
// EXTERNAL MODULE: ./_modules/study/home/footer_carousel/loader/loader.module.scss
var footer_carousel_loader_loader_module = __webpack_require__(91734);
var footer_carousel_loader_loader_module_default = /*#__PURE__*/__webpack_require__.n(footer_carousel_loader_loader_module);
;// CONCATENATED MODULE: ./_modules/study/home/footer_carousel/loader/index.jsx





var HomeThepressLoader = function HomeThepressLoader() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        className: (footer_carousel_loader_loader_module_default()).title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        className: (footer_carousel_loader_loader_module_default()).press
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        className: (footer_carousel_loader_loader_module_default()).press
      })]
    })
  });
};

/* harmony default export */ var footer_carousel_loader = (HomeThepressLoader);
// EXTERNAL MODULE: ./_modules/study/home/tab/loader/loader.module.scss
var tab_loader_loader_module = __webpack_require__(4831);
var tab_loader_loader_module_default = /*#__PURE__*/__webpack_require__.n(tab_loader_loader_module);
;// CONCATENATED MODULE: ./_modules/study/home/tab/loader/index.jsx





var HomeTabLoader = function HomeTabLoader() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (tab_loader_loader_module_default()).tab,
      children: new Array(3).fill(1).map(function (_, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          height: 70
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (tab_loader_loader_module_default()).grid,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (tab_loader_loader_module_default()).content,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          height: 140,
          style: {
            marginBottom: "20px"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          height: 300
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        height: 350
      })]
    })]
  });
};

/* harmony default export */ var tab_loader = (HomeTabLoader);
// EXTERNAL MODULE: ./_modules/study/home/unisearch_student/loader/loader.module.scss
var unisearch_student_loader_loader_module = __webpack_require__(14110);
var unisearch_student_loader_loader_module_default = /*#__PURE__*/__webpack_require__.n(unisearch_student_loader_loader_module);
;// CONCATENATED MODULE: ./_modules/study/home/unisearch_student/loader/index.jsx





var HomeStudentLoader = function HomeStudentLoader(_ref) {
  var isImageRight = _ref.isImageRight;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (unisearch_student_loader_loader_module_default()).grid,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
          className: (unisearch_student_loader_loader_module_default()).image,
          style: {
            order: isImageRight ? "1" : "-1"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
            className: (unisearch_student_loader_loader_module_default()).title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
            className: (unisearch_student_loader_loader_module_default()).sub_title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(skeleton/* default */.Z, {
            className: (unisearch_student_loader_loader_module_default()).button
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var unisearch_student_loader = (HomeStudentLoader);
// EXTERNAL MODULE: ./_unisearch/common/advertisement/row/index.jsx
var row = __webpack_require__(75693);
;// CONCATENATED MODULE: ./pages/index.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var VirtualOfficePopup = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1049).then(__webpack_require__.bind(__webpack_require__, 61049));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61049)];
    }
  }
});
var HomeBanner = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9778).then(__webpack_require__.bind(__webpack_require__, 69778));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(banner_loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(69778)];
    }
  }
});
var HomeTab = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2555).then(__webpack_require__.bind(__webpack_require__, 22555));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(tab_loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(22555)];
    }
  }
});
var CountdownTwo = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9846).then(__webpack_require__.bind(__webpack_require__, 9846));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9846)];
    }
  }
});
var FindUniversity = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 5698).then(__webpack_require__.bind(__webpack_require__, 15698));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(find_university_loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(15698)];
    }
  }
});
var UnisearchStudent = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1240).then(__webpack_require__.bind(__webpack_require__, 71240));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(unisearch_student_loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(71240)];
    }
  }
});
var UnisearchUniversity = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1670).then(__webpack_require__.bind(__webpack_require__, 41670));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(unisearch_student_loader, {
      isImageRight: true
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(41670)];
    }
  }
});
var FooterCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(4744)]).then(__webpack_require__.bind(__webpack_require__, 90213));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(footer_carousel_loader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(90213)];
    }
  }
});
var backgroundImage = (0,helpers/* getAssets */.Vh)("assets/images/home/slice-left.webp");

var Home = function Home() {
  var _useRecoilState = (0,recoil/* useRecoilState */.FV)(search_popup/* searchPopupState */.F),
      _useRecoilState2 = (0,slicedToArray/* default */.Z)(_useRecoilState, 2),
      _ = _useRecoilState2[0],
      setPopupState = _useRecoilState2[1];

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      popupCloseState = _useState2[0],
      setPopupCloseState = _useState2[1];

  var _useInView = (0,react_intersection_observer_modern/* useInView */.YD)(),
      ref = _useInView.ref,
      inView = _useInView.inView;

  (0,react.useEffect)(function () {
    if (window !== undefined) {
      js_cookie/* default.set */.Z.set("referrer", document.referrer);
    }
  }, []);

  var handleClose = function handleClose() {
    setOpen(false);
    setPopupCloseState(true);
    setPopupState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isOpenHomePagePopup: false
      });
    });
  };

  (0,react.useEffect)(function () {
    if (inView && !popupCloseState) {
      setOpen(true);
      setPopupState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          isOpenHomePagePopup: true
        });
      });
    }
  }, [inView, popupCloseState, setPopupState]);

  var jsonLd = function jsonLd() {
    return {
      __html: "\n      [\n        {\n        \"@context\": \"https://schema.org\",\n        \"@type\": \"Organization\",\n        \"name\": \"UniSearch\",\n        \"alternateName\": \"UniSearch\",\n        \"url\": \"https://myunisearch.com/\",\n        \"logo\": \"".concat("https://myunisearch.com", "/assets/logo_dark.png\",\n        \"sameAs\": [\n          \"https://www.facebook.com/UniSearchIndia\",\n          \"https://twitter.com/myunisearch\",\n          \"https://www.youtube.com/channel/UCCHQrxOr5olDBxypJUE7qZw\",\n          \"https://myunisearch.com/\"\n        ]\n        },\n          {\n            \"@context\": \"http://schema.org\",\n            \"@type\": \"WebSite\",\n            \"name\": \"UniSearch\",\n            \"url\": \"https://myunisearch.com/\",\n            \"potentialAction\": {\n                \"@type\": \"SearchAction\",\n                \"target\": {\n                    \"@type\": \"EntryPoint\",\n                    \"urlTemplate\": \"https://myunisearch.com/search?ref=general&refq={search_term_string}&limit=10&page=1\"\n                },\n                \"query-input\": \"required name=search_term_string\"\n            }\n        }\n      ]")
    };
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(layout/* LayoutMain */.Ku, {
      footer_with_evaluation: true,
      fixedPopup: false,
      title: "",
      metaTitle: "",
      metaKeywords: "unisearch, study abroad, apply university, study",
      metaDescription: "Bringing international student experience and intelligent technology together to make study abroad solutions simpler than ever",
      metaImage: (0,helpers/* getAssets */.Vh)("assets/home.png"),
      metaUrl: "https://myunisearch.com",
      JsonLd: jsonLd,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HomeBanner, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "lg:mt-[-50px] mb-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
          srcDesktop: "/ad/study-in-au.webp",
          srcMobile: "/ad/study-in-au-mobile.webp",
          url: "https://myunisearch.com/lead/apply-for-scholarships-at-the-victoria-university"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HomeTab, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(CountdownTwo, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(FindUniversity, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-7 lg:mt-[-50px] lg:mb-[-32px]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
          srcDesktop: "/ad/study-in-au-v2.webp",
          srcMobile: "/ad/study-in-au-mobile.webp",
          url: "https://myunisearch.com/lead/apply-for-scholarships-at-the-victoria-university"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: ref
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: {
          backgroundImage: "url(".concat(backgroundImage, ")"),
          backgroundRepeat: "no-repeat",
          backgroundPosition: "left bottom"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(UnisearchStudent, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(UnisearchUniversity, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FooterCarousel, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      "aria-labelledby": "transition-modal-title",
      "aria-describedby": "transition-modal-description",
      open: open,
      onClose: handleClose,
      closeAfterTransition: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "modal sm",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          style: {
            position: "absolute",
            top: "24px",
            right: "10px",
            zIndex: 10
          },
          className: "cross_icon",
          onClick: handleClose,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(VirtualOfficePopup, {})]
      })
    })]
  });
};

/* harmony default export */ var pages = (Home);

/***/ }),

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(17948);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__17R2F","counter":"loader_counter__tI_1p","heading":"loader_heading__EWpI7","text":"loader_text__tkvKX","content":"loader_content__8DbZY"};

/***/ }),

/***/ 74544:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__DnrrU","title":"loader_title__WExIf","sub_title":"loader_sub_title__QfrLo","search":"loader_search__rxH8t","features":"loader_features__IHXOi"};

/***/ }),

/***/ 38814:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"loader_title___b5ZH","sub_title":"loader_sub_title__N7o8R","grid":"loader_grid__34iro"};

/***/ }),

/***/ 91734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"loader_title__WypxJ","press":"loader_press__OyMif"};

/***/ }),

/***/ 4831:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab":"loader_tab__Zje7P","grid":"loader_grid___4fF0"};

/***/ }),

/***/ 14110:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__L_RH5","image":"loader_image__USXs3","title":"loader_title__zrZPd","sub_title":"loader_sub_title__j2WN8","button":"loader_button__Xf_1I"};

/***/ }),

/***/ 97650:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _state$entry;

  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: undefined
  }); // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.

  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    let unobserve = observe(ref, (inView, entry) => {
      setState({
        inView,
        entry
      });
      if (callback.current) callback.current(inView, entry);

      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root,
      rootMargin,
      threshold,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
    return () => {
      if (unobserve) {
        unobserve();
      }
    };
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!ref && entryTarget && !triggerOnce && !skip) {
      // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView,
        entry: undefined
      });
    }
  }, [ref, entryTarget, triggerOnce, skip, initialInView]);
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5445,5937,2013,4617,955,9866,3874,6556,7662,2884,8719,8322,1496,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);